(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-collection"] && !Shopify.designMode) return;
  try {
    
  class AnimatedCollection {
    constructor(section) {
      this.section = section;
      this.container = section.container;
      this.buttons = this.container.querySelectorAll('[data-hover-target]');
      this.images = this.container.querySelectorAll('[data-collection-image]');
      this.rafId = null;
      this.init();
    }

    init() {
      if (!this.buttons.length || !this.images.length) return;

      this.buttons.forEach((btn) => {
        btn.addEventListener('mouseenter', (e) => {
          if (window.innerWidth >= 768) {
            this.setActive(btn.getAttribute('data-hover-target'));
          }
        });
      });

      this.initMobileScroll();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.initMobileScroll();
        }, 250);
      });
    }

    setActive(targetId) {
      this.buttons.forEach((btn) => {
        btn.classList.toggle('is-selected', btn.getAttribute('data-hover-target') === targetId);
      });

      this.images.forEach((img) => {
        img.classList.toggle('is-visible', img.id === targetId);
      });
    }

    initMobileScroll() {
      const isMobile = window.innerWidth < 768;

      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }

      if (isMobile) {
        this.scrollHandler = () => {
          if (!this.rafId) {
            this.rafId = requestAnimationFrame(() => {
              this.updateActiveOnScroll();
              this.rafId = null;
            });
          }
        };

        window.addEventListener('scroll', this.scrollHandler);
        this.updateActiveOnScroll();
      }
    }

    updateActiveOnScroll() {
      const midpoint = window.innerHeight / 2;

      for (let i = 0; i < this.images.length; i++) {
        const rect = this.images[i].getBoundingClientRect();

        if (rect.top <= midpoint && rect.bottom >= midpoint) {
          const targetId = this.images[i].id;
          const btn = this.buttons[i];

          if (btn && !btn.classList.contains('is-selected')) {
            this.buttons.forEach((b) => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
          }
          break;
        }
      }
    }

    onUnload() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }
  }

  if (typeof register === 'function') {
    register('animated-collection', {
      onLoad() {
        this.animatedCollection = new AnimatedCollection(this);
      },
      onUnload() {
        if (this.animatedCollection) {
          this.animatedCollection.onUnload();
        }
      },
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof register !== 'function') {
      document.querySelectorAll('[data-section-type="animated-collection"]').forEach((section) => {
        new AnimatedCollection({ container: section });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('theme-announcement')) {
    customElements.define(
      'theme-announcement',
      class ThemeAnnouncement extends HTMLElement {
        connectedCallback() {
          this.storageKey = `announcement-bar-dismissed-${this.dataset.sectionId}`;
          this.items = Array.from(this.querySelectorAll('.theme-announcement__slider .theme-announcement__item'));
          this.currentIndex = 0;
          this.timer = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (this.dataset.dismissible === 'true' && sessionStorage.getItem(this.storageKey) === 'true') {
            this.hide(true);
            return;
          }

          this.setHeight();
          this.resizeObserver = new ResizeObserver(() => this.setHeight());
          this.resizeObserver.observe(this);

          const dismissButton = this.querySelector('.theme-announcement__dismiss');
          if (dismissButton) {
            dismissButton.addEventListener('click', () => this.dismiss());
          }

          if (this.items.length > 1 && this.dataset.autoplay === 'true' && !this.reducedMotion.matches) {
            this.startAutoplay();
            this.addEventListener('mouseenter', () => this.stopAutoplay());
            this.addEventListener('mouseleave', () => this.startAutoplay());
            this.addEventListener('focusin', () => this.stopAutoplay());
            this.addEventListener('focusout', () => this.startAutoplay());
          }
        }

        disconnectedCallback() {
          this.stopAutoplay();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          document.documentElement.style.removeProperty('--announcement-bar-height');
        }

        setHeight() {
          if (this.classList.contains('is-hidden')) {
            document.documentElement.style.setProperty('--announcement-bar-height', '0px');
            return;
          }
          document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
        }

        startAutoplay() {
          this.stopAutoplay();
          const speed = Number(this.dataset.speed || 5) * 1000;
          this.timer = setInterval(() => this.showNext(), speed);
        }

        stopAutoplay() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        showNext() {
          if (!this.items.length) return;
          const nextIndex = (this.currentIndex + 1) % this.items.length;
          this.items[this.currentIndex].classList.remove('is-active');
          this.items[this.currentIndex].setAttribute('aria-hidden', 'true');
          const currentLink = this.items[this.currentIndex].querySelector('a');
          if (currentLink) currentLink.setAttribute('tabindex', '-1');

          this.currentIndex = nextIndex;
          this.items[this.currentIndex].classList.add('is-active');
          this.items[this.currentIndex].removeAttribute('aria-hidden');
          const nextLink = this.items[this.currentIndex].querySelector('a');
          if (nextLink) nextLink.setAttribute('tabindex', '0');
        }

        dismiss() {
          sessionStorage.setItem(this.storageKey, 'true');
          this.hide();
        }

        hide(instant = false) {
          if (instant) this.style.transition = 'none';
          this.classList.add('is-hidden');
          this.setHeight();
          this.stopAutoplay();
          this.setAttribute('aria-hidden', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-slider')) {
    class FeaturedCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fc-track]');
        this.prevBtn = this.querySelector('[data-fc-prev]');
        this.nextBtn = this.querySelector('[data-fc-next]');
        this.currentEl = this.querySelector('[data-fc-current]');
        this.totalEl = this.querySelector('[data-fc-total]');
        this.progressEl = this.querySelector('[data-fc-progress]');
        if (!this.track) return;

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
        this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      pageWidth() {
        const slide = this.track.querySelector('.featured-collection__slide');
        if (!slide) return this.track.clientWidth;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const slideWidth = slide.getBoundingClientRect().width + gap;
        const columns = Math.max(1, Math.round(this.track.clientWidth / slideWidth));
        return slideWidth * columns;
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: this.pageWidth() * direction, behavior: 'smooth' });
      }

      onScroll() {
        window.requestAnimationFrame(() => this.update());
      }

      update() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const pageSize = Math.max(1, this.pageWidth());
        const pages = maxScroll <= 2 ? 1 : Math.ceil((maxScroll + pageSize * 0.05) / pageSize);
        const current = maxScroll <= 2 ? 1 : Math.min(pages, Math.floor((this.track.scrollLeft + pageSize * 0.25) / pageSize) + 1);
        const progress = maxScroll <= 2 ? 100 : Math.min(100, Math.max(8, (this.track.scrollLeft / maxScroll) * 100));

        if (this.progressEl) this.progressEl.style.width = `${progress}%`;
        if (this.currentEl) this.currentEl.textContent = String(current);
        if (this.totalEl) this.totalEl.textContent = String(pages);
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }

    customElements.define('featured-collection-slider', FeaturedCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-related-products"] && !Shopify.designMode) return;
  try {
    
  class TabSwitch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeTabs();
    }

    initializeTabs() {
      this.tabButtons = this.querySelectorAll('input[type="radio"]');
      this.relatedProducts = this.querySelector('product-recommendations');
      this.recentlyViewed = this.querySelector('recently-viewed');

      // Hide recently viewed by default
      if (this.recentlyViewed) {
        this.recentlyViewed.style.display = 'none';
      }

      // Add event listeners to tab buttons
      this.tabButtons.forEach((button) => {
        button.addEventListener('change', this.handleTabChange.bind(this));
      });

      // Initialize the first tab as active
      const checkedTab = this.querySelector('input[type="radio"]:checked');
      if (checkedTab) {
        this.handleTabChange({ target: checkedTab });
      }
    }

    handleTabChange(event) {
      const tabIndex = event.target.dataset.tabIndex;

      if (tabIndex === '1') {
        // Show related products
        if (this.relatedProducts) {
          this.relatedProducts.style.display = 'block';
          // Initialize related products if not already loaded
          if (!this.relatedProducts.classList.contains('product-recommendations--loaded')) {
            this.relatedProducts.initializeRecommendations?.();
          }
        }
        if (this.recentlyViewed) {
          this.recentlyViewed.style.display = 'none';
        }
      } else if (tabIndex === '2') {
        // Show recently viewed
        if (this.recentlyViewed) {
          this.recentlyViewed.style.display = 'block';
          // Initialize recently viewed if not already loaded
          if (!this.recentlyViewed.classList.contains('product-recommendations--loaded')) {
            this.recentlyViewed.initializeRecentlyViewed?.();
          }
        }
        if (this.relatedProducts) {
          this.relatedProducts.style.display = 'none';
        }
      }

      // Update active state for labels
      this.updateActiveStates(event.target);
    }

    updateActiveStates(activeInput) {
      // Remove active class from all labels
      const labels = this.querySelectorAll('.tab--button');
      labels.forEach((label) => {
        label.classList.remove('active');
      });

      // Add active class to the parent label of checked input
      const activeLabel = activeInput.closest('.tab--button');
      if (activeLabel) {
        activeLabel.classList.add('active');
      }
    }
  }

  customElements.define('tab-switch', TabSwitch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-look-modal')) {
    class ShopTheLookModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.shop-the-look-modal__dialog');
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        this.querySelectorAll('[data-shop-the-look-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeyDown);
        document.body.classList.remove('shop-the-look-modal-open');
        this.classList.remove('is-open');
      }

      onDocumentClick(event) {
        const openBtn = event.target.closest('[data-shop-the-look-open]');
        if (openBtn) {
          event.preventDefault();
          this.open();
        }
      }

      onKeyDown(event) {
        if (event.key === 'Escape') this.close();
      }

      open() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }
        this.hidden = false;
        document.body.classList.add('shop-the-look-modal-open');
        document.addEventListener('keydown', this.onKeyDown);
        requestAnimationFrame(() => {
          this.classList.add('is-open');
          this.dialog?.focus();
        });
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('shop-the-look-modal-open');
        document.removeEventListener('keydown', this.onKeyDown);
        window.setTimeout(() => {
          this.hidden = true;
        }, 200);
      }
    }

    customElements.define('shop-the-look-modal', ShopTheLookModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-video-carousel')) {
    class ShoppableVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sv-track]');
        this.prevBtn = this.querySelector('[data-sv-prev]');
        this.nextBtn = this.querySelector('[data-sv-next]');
        this.videos = Array.from(this.querySelectorAll('video.shoppable-video__video'));

        if (!this.track) return;

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        }

        this.setupAutoplayObserver();
        this.updateNav();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.observer) this.observer.disconnect();
      }

      cardStep() {
        const card = this.track.querySelector('.shoppable-video__card');
        if (!card) return this.track.clientWidth * 0.8;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({ left: this.cardStep() * direction, behavior: 'smooth' });
      }

      updateNav() {
        if (!this.prevBtn && !this.nextBtn) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        const left = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = left <= 2;
        if (this.nextBtn) this.nextBtn.disabled = left >= maxScroll;
      }

      onScroll() {
        window.requestAnimationFrame(() => this.updateNav());
      }

      setupAutoplayObserver() {
        if (!('IntersectionObserver' in window) || this.videos.length === 0) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: [0.55] }
        );

        this.videos.forEach((video) => this.observer.observe(video));
      }
    }

    customElements.define('shoppable-video-carousel', ShoppableVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-description"] && !Shopify.designMode) return;
  try {
    
  class SizeTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeTabs();
    }

    initializeTabs() {
      this.tabButtons = this.querySelectorAll('input[type="radio"]');
      this.relatedProducts = this.querySelector('.size-section');
      this.recentlyViewed = this.querySelector('.video-text-section');

      // Add event listeners to tab buttons
      this.tabButtons.forEach((button) => {
        button.addEventListener('change', this.handleTabChange.bind(this));
      });

      // Initialize the first tab as active
      const checkedTab = this.querySelector('input[type="radio"]:checked');
      if (checkedTab) {
        this.handleTabChange({ target: checkedTab });
      }
    }

    handleTabChange(event) {
      const tabIndex = event.target.dataset.tabIndex;

      if (tabIndex === '1') {
        // Show related products
        if (this.relatedProducts) {
          this.relatedProducts.classList.remove('hidden');
        }
        if (this.recentlyViewed) {
          this.recentlyViewed.classList.add('hidden');
        }
      } else if (tabIndex === '2') {
        if (this.recentlyViewed) {
          this.recentlyViewed.classList.remove('hidden');
        }
        if (this.relatedProducts) {
          this.relatedProducts.classList.add('hidden');
        }
      }

      // Update active state for labels
      this.updateActiveStates(event.target);
    }

    updateActiveStates(activeInput) {
      const labels = this.querySelectorAll('.tab--button');
      labels.forEach((label) => {
        label.classList.remove('active');
      });

      const activeLabel = activeInput.closest('.tab--button');
      if (activeLabel) {
        activeLabel.classList.add('active');
      }
    }
  }

  customElements.define('size-tab', SizeTab);

  } catch(e) { console.error(e); }
})();
})();
